<h2>Hur tänker {{ plrDuNi.toLowerCase() }} kring {{ plrDittErt.toLowerCase() }}
  boende?</h2>
<form [formGroup]="form" class="spb-form">
  <div>
    <h3 class="question-with-hint">Hur skulle hushållets ekonomi påverkas om något inträffar som
      påverkar {{ plrDinaEra.toLowerCase() }} inkomster
      eller utgifter på ett väsentligt sätt?</h3>
    <p class="question-hint">Med väsentlig påverkan avses en större förändring i din ekonomi som påverkar din förmåga att klara löpande kostnader. Det kan till exempel vara att inkomsten minskar vid sjukskrivning eller arbetslöshet, eller att utgifterna ökar genom högre räntor eller oväntade kostnader.</p>
    <mat-radio-group
        (change)="changeRadioButton($event, 3)"
        aria-label="Hur skulle hushållets ekonomi påverkas om något inträffar som påverkar dina inkomster eller utgifter
      på ett väsentligt sätt?"
    >
      <mat-radio-button [checked]="form.controls.q3.value === 1" [value]="1">{{ plrJagVi }}
        kan hantera stora förändringar utan att det
        påverkar {{ plrMinVar.toLowerCase() }} möjlighet att betala räntor och
        amorteringar på
        {{ plrMinaVara.toLowerCase() }} bolån
      </mat-radio-button>
      <mat-radio-button [checked]="form.controls.q3.value === 2" [value]="2">{{ plrJagVi }}
        kan hantera vissa förändringar utan att det påverkar {{ plrMinVar.toLowerCase() }} möjlighet att betala räntor
        och amorteringar på{{ plrMinaVara.toLowerCase() }} bolån
      </mat-radio-button>
      <mat-radio-button [checked]="form.controls.q3.value === 3" [value]="3">{{ plrJagVi }}
        har
        små marginaler och kan bara hantera
        mindre förändringar utan att det
        påverkar {{ plrMinVar.toLowerCase() }} möjlighet att betala räntor och
        amorteringar på {{ plrMinaVara.toLowerCase() }} bolån
      </mat-radio-button>
    </mat-radio-group>

    <h3>Tror {{ plrDuNi.toLowerCase() }} att hushållets ekonomi kommer att
      påverkas i stor grad de närmaste tre åren?</h3>
    <mat-radio-group
        (change)="changeRadioButton($event, 4)"
        aria-label="Tror du att hushållets ekonomi kommer att påverkas negativt de närmaste tre åren?"
    >
      <mat-radio-button [checked]="form.controls.q4.value === 1" [value]="1">Nej
      </mat-radio-button>
      <mat-radio-button [checked]="form.controls.q4.value === 2" [value]="2">Ja, på ett
        positivt sätt ({{ plrJagVi.toLowerCase() }} kommer
        att få ökade inkomster och/eller minskade kostnader utöver det
        normala)
      </mat-radio-button>
      <mat-radio-button [checked]="form.controls.q4.value === 3" [value]="3">Ja, på ett
        negativt sätt ({{ plrJagVi.toLowerCase() }}
        kommer att få minskade inkomster och/eller ökade kostnader utöver det
        normala)
      </mat-radio-button>
    </mat-radio-group>

    <h3>Har hushållet en buffert i form av sparande eller andra tillgångar så
      att ni kan klara ökade
      räntekostnader?</h3>
    <mat-radio-group
        (change)="changeRadioButton($event, 5)"
        aria-label="Har hushållet en buffert i form av sparande eller andra tillgångar så att ni kan klara ökade räntekostnader?"
    >
      <mat-radio-button [checked]="form.controls.q5.value === 1" [value]="1">{{ plrJagVi }}
        kan
        hantera stora räntehöjningar under en lång
        period med hjälp av sparande eller annat
      </mat-radio-button>
      <mat-radio-button [checked]="form.controls.q5.value === 2" [value]="2">{{ plrJagVi }}
        kan
        hantera räntehöjningar i viss omfattning
        och under en begränsad period med hjälp av sparande eller annat
      </mat-radio-button>
      <mat-radio-button [checked]="form.controls.q5.value === 3" [value]="3">{{ plrJagVi }}
        kan
        endast hantera mindre räntehöjningar och
        under en begränsad period med hjälp av sparande eller annat
      </mat-radio-button>
    </mat-radio-group>

    <h3>Hur länge planerar {{ plrDuNi.toLowerCase() }} att bo kvar i
      bostaden?</h3>
    <mat-radio-group
        (change)="changeRadioButton($event, 6)"
        aria-label="Hur länge planerar du att bo kvar i bostaden?"
    >
      <mat-radio-button [checked]="form.controls.q6.value === 1" [value]="1">Mindre än ett
        år
      </mat-radio-button>
      <mat-radio-button [checked]="form.controls.q6.value === 2" [value]="2">Mer än ett år,
        men mindre än fem år
      </mat-radio-button>
      <mat-radio-button [checked]="form.controls.q6.value === 3" [value]="3">Mer än fem år
      </mat-radio-button>
    </mat-radio-group>
  </div>
</form>
